import React, { useState } from "react";
import WmsModel from "../../components/WmsModel/WmsModel";
import WmsDropdownList from "../../components/WmsDropdownList/WmsDropdownList";
import WmsButton from "../../components/WmsButton/WmsButton";
import * as auditInventoryServices from "./../audit-inventory.services";
import * as GlobalService from "./../../global_services";

declare var window: any;

interface Props {
    isOpen: boolean;
    onCloseFunc: (isRefreshGrid?: boolean) => void;
    wmsSelector: string;
    windowId: string;
    selectedRowData: any;
    batchList: any;
    facId: number;
}

const AddToExistingBatchModal: React.FC<Props> = (incomingProps: Props) => {
    const {
        isOpen = false,
        wmsSelector = "",
        windowId = "",
        selectedRowData = [],
        batchList = [],
        facId = 0,
    } = incomingProps;
    const props = {
        ...incomingProps,
        isOpen,
        wmsSelector,
        windowId,
        selectedRowData,
        batchList,
        facId,
    };

    const [selectedBatch, setSelectedBatch] = useState<any>(null);
    const [isSaveToBatchLoading, setIsSaveToBatchLoading] = useState(false);

    const onChangeBatch = (e: any) => {
        setSelectedBatch(e.target.value);
    };

    const onSaveBatch = () => {
        setIsSaveToBatchLoading(true);
        const editBatchData = {
            batch: {
                Name: selectedBatch.Name,
                Priority: selectedBatch.Priority,
                AssignedUser: selectedBatch.AssignedUser,
                InventoryAuditIds: [
                    ...selectedBatch.InventoryAuditIds,
                    ...props.selectedRowData.map((item: any) => parseInt(item.EditUri?.split("/").pop())),
                ],
            },
            editUri: selectedBatch._links[0].Href,
        };
        auditInventoryServices
            .editBatch(editBatchData)
            .then(() => {
                GlobalService.notification("success", window.translate("Label_Batch_Updated_Successfully"));

                setIsSaveToBatchLoading(false);
                props.onCloseFunc(true);
            })
            .catch((error) => {
                console.log("error", error);
                setIsSaveToBatchLoading(false);
                GlobalService.notification("error", error.data.Message);
            });
    };

    return (
        <WmsModel
            id="AddToExistingBatchModal"
            title={window.translate("Label_Add_Orders_To_Existing_Batch")}
            width={665}
            height={800}
            onCloseFunc={props.onCloseFunc}
            isOpen={props.isOpen}
            customClass="wms-model-new-ui-wrapper"
            actions={[]}
            overlayHide={false}
            windowId={props.windowId}
            appendTo={"#" + props.windowId}
        >
            <div className={"model-content-wrapper"}>
                <WmsDropdownList
                    id={"selectedBatch"}
                    wmsSelector={props.wmsSelector + "selectedBatch"}
                    onChangeFunc={onChangeBatch}
                    valueField="Name"
                    textField="Name"
                    isVirtualOptions={false}
                    staticOptions={props.batchList}
                    extraWrapperClass="assigned-to-wrapper"
                    label={window.translate("Label_Choose_Batch")}
                />
            </div>
            <div className="footer-btn-holder">
                <WmsButton
                    label={window.translate("Label_Cancel")}
                    wmsSelector={props.wmsSelector + "DiscardExit"}
                    onClickFunc={props.onCloseFunc}
                    buttonType="orange"
                    icon={"fa-ban"}
                />
                <WmsButton
                    label={window.translate("Label_Save")}
                    wmsSelector={props.wmsSelector + "Save"}
                    onClickFunc={onSaveBatch}
                    disabled={!selectedBatch || selectedBatch.Name === ""}
                    icon={"fa-floppy-o"}
                    loading={isSaveToBatchLoading}
                    parentClassName={"apply-adjustment-button"}
                />
            </div>
        </WmsModel>
    );
};

export default React.memo(AddToExistingBatchModal);
